import { sendGTMEvent } from '@next/third-parties/google'

type EventName =
  | 'click_cta'
  | 'view_item'
  | 'click_cta_period'
  | 'click_cta_selection'
  | 'click_cta_search'
  | 'click_cta_search_results'
  | 'click_cta_filter'
  | 'click_cta_button'
  | 'click_recommendation_hdp'
  | 'view_cart'
  | 'add_payment_info'
  | 'click_cta_newsletter'
  | 'experience_no_offers'
  | 'accommodation_no_offers'
  | 'website_message'
  | 'view_item_list'
  | 'map_interaction'
  | 'add_to_wishlist'
  | 'remove_from_wishlist'
  | 'view_wishlist_modal'
  | 'select_wishlist'
  | 'create_wishlist'
  | 'share_wishlist'
  | 'select_item'
  | 'cart_add_promo_code'
  | 'cart_submit_promo_code'
  | 'checkout_add_promo_code'
  | 'checkout_submit_promo_code'
  | 'experiment_viewed'
  | 'partner_profile_entry_click'
  | 'partner_profile_experience_click'

type TrackingPayload = { [key: string]: unknown; event: EventName }

export function trackEvent(payload: TrackingPayload) {
  sendGTMEvent(payload)
}
